import React from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ApiConstants } from '../constants/ApiConstants'
import { ApiTypes } from '../constants/Constants'
import FrontLoader from '../component/layout/FrontLoader'
import { LanguageConstants } from '../constants/LanguageConstants'
import { getProductDeleteModalCopy } from '../constants/ProductDeleteModalCopy'
import { socket } from '../utils/Socket'
function Productdelete(props:any) {
    const productdelete = useMakeRequest()
    const navigate = useNavigate()
    const copy = getProductDeleteModalCopy()
    const handleDelete =()=>{
      if (props?.onConfirmLocalDelete) {
        props.onConfirmLocalDelete()
        return
      }
      const payload ={
        product_id :props?.data?.id,
        quotation_id:props?.data?.quotation_id,
        s_no:props?.s_no 
      }
      productdelete.makeRequest({ payload, type:ApiTypes.POST, url: ApiConstants?.QuotesProductdelete, toastStatus: true })
    }
useEffect(()=>{
   if(productdelete?.status){
    props?.setProductDelete(false)
    const socketpayload ={
          sender_type: "1",
          receiver_id: '1'
        }
        socket.emit('admin_count', socketpayload, async (Response: any) => { })
    navigate('/my-quotation')
   }
 },[productdelete?.status])
  return (
    <>
    {productdelete?.loading ? <FrontLoader/> : null}
    <div className="modal fade com-modal short-modal show" id="editMessageProductModal" aria-labelledby="editMessageProductModalLabel" aria-hidden="false"  style={{display: "block"}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editMessageProductModalLabel">{copy.title}</h5>
                            <button onClick={()=>props?.setProductDelete(false)}  type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <p className="modal-para mt-2">{copy.message}</p>
                        </div>
                        <div className="modal-footer">
                            <div className="row w-100">
                                <div className="col-6 ps-0">
                                    <button onClick={()=>props?.setProductDelete(false)}  className="round-btn round-btn-gray m-0 w-100" >{LanguageConstants?.CANCEL}</button>
                                </div>
                                <div className="col-6 pe-0">
                                    <button type="submit" className="round-btn m-0 w-100"  onClick={()=>handleDelete()}  >{copy.confirm}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
    </>
  )
}

export default Productdelete
